/**
 *  @function evalute - evaluate dateDiffBehavior
 */

const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

// example of local module included within a config-js release
const _require2 = require('./shared/dateDiff'),
  dateDiffInSeconds = _require2.dateDiffInSeconds;
const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const fromDate = await evaluateSource(source.fromDate, content, parentContentPath, transientContext, nativeFunctions);
  const toDate = await evaluateSource(source.toDate, content, parentContentPath, transientContext, nativeFunctions);
  return dateDiffInSeconds(toDate, fromDate);
};
module.exports = {
  evaluate
};